export default (ldflag) => (nextState, replace, callback) => {
    if (!ldflag) {
        replace({ pathname: "/404" });
    }
    callback();
};
